import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingExperience from '../components/LoadingExperience';
import { Button } from '../components/ui/button';

function LoadingDemo() {
  const navigate = useNavigate();
  const [showLoading, setShowLoading] = useState(true);
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    if (showLoading && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      setShowLoading(false);
    }
  }, [showLoading, countdown]);

  const handleRestart = () => {
    setCountdown(30);
    setShowLoading(true);
  };

  if (showLoading) {
    return (
      <>
        <LoadingExperience isVisible={true} estimatedDuration={30} />
        {/* Demo controls overlay */}
        <div className="fixed bottom-4 left-4 z-[60] bg-black/80 text-white p-4 rounded-lg text-sm">
          <p className="font-bold mb-2">Demo Mode</p>
          <p>Auto-closes in: {countdown}s</p>
          <Button 
            onClick={() => setShowLoading(false)} 
            variant="outline" 
            className="mt-2 text-xs bg-white text-black hover:bg-gray-100"
            size="sm"
          >
            Skip Demo
          </Button>
        </div>
      </>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-slate-900 mb-4">Loading Demo Complete</h1>
        <p className="text-slate-600 mb-8">The loading experience has finished.</p>
        <div className="flex gap-4 justify-center">
          <Button onClick={handleRestart} className="bg-[#0066CC] text-white rounded-full px-8">
            Replay Demo
          </Button>
          <Button onClick={() => navigate('/')} variant="outline" className="rounded-full px-8">
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LoadingDemo;
